export default __webpack_public_path__ + "static/media/pacifier.214c0178.png";